<div class="powered-by" *ngIf="exibirPoweredBy">
    <i class="fas fa-heart" style="color: #ff6b6b; margin-right: 4px; font-size: 10px;"></i>
    <a href="https://meucardapio.ai" target="_blank" style="color: #6c757d; text-decoration: none;">Feito por &nbsp;<img src="https://fibo.promokit.com.br/lp/cardapio/images/logo-meucardapio.png" style="width: 45px;"/> </a>
    <i class="fas fa-sparkles" style="color: #ffd93d; margin-left: 4px; font-size: 9px;"></i>
</div>
